import './App.css';
import {
  Redirect, Route, BrowserRouter as Router,
  Switch, withRouter,
} from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import DownloadDeviceReport from '../pages/downloadDeviceReportPage/DownloadDeviceReportPage';
import DatapointAnalysis from '../pages/datapointAnalysisPage/DatapointAnalysisPage';
import DatapointTransmissionTrends from '../pages/datapointTransmissionTrendsPage/DatapointTransmissionTrendsPage';
import DeviceDetails from '../pages/deviceDetailsPage/DeviceDetailsPage';
import DeviceSWAnalysis from '../pages/deviceSWAnalysisPage/DeviceSWAnalysisPage';
import DeviceTrends from '../pages/deviceTrendsPage/DeviceTrendsPage';
import DeviceUsageAnalysis from '../pages/deviceUsageAnalysisPage/DeviceUsageAnalysisPage';
import LoginPage from '../pages/loginPage/LoginPage';
import MainLayout from '../mainLayout/MainLayout';
import NotificationAnalysis from '../pages/notificationAnalysisPage/NotificationAnalysisPage';
import OnboardingAnalysis from '../pages/onboardingAnalysisPage/OnboardingAnalysisPage';
import Overview from '../pages/overviewPage/OverviewPage';
import MeteredUsage from '../pages/meteredUsagePage/MeteredUsagePage';
import UserAnalysis from '../pages/userAnalysisPage/UserAnalysisPage';
import AuthenticationPage from '../pages/authenticationPage/AuthenticationPage';
import { hideErrors } from '../../reducer/actions';
import Devices from '../pages/devicesPage/DevicesPage';
import Transactions from '../pages/transactionsPage/TransactionsPage';

import Schedules from '../tensorAnalytics/pages/schedules/Schedules';
import Models from '../tensorAnalytics/pages/models/Models';
import DeviceDetail from '../tensorAnalytics/pages/deviceDetailPage/DeviceDetailPage';
import FailurePrediction from '../tensorAnalytics/pages/failurePrediction/FailurePrediction';
import AnalyticsDashboard from '../tensorAnalytics/pages/analyticsDashboardPage/AnalyticsDashboardPage';
import DetectionResults from '../tensorAnalytics/pages/detectionResults/DetectionResults';
import DragDrop from '../tensorAnalytics/subComponents/dragDrop/DragDrop';

import SchedulesDev from '../tensorAnalyticsDev/pages/schedules/Schedules';
import ModelsDev from '../tensorAnalyticsDev/pages/models/Models';
import DeviceDetailDev from '../tensorAnalyticsDev/pages/deviceDetailPage/DeviceDetailPage';
import FailurePredictionDev from '../tensorAnalyticsDev/pages/failurePrediction/FailurePrediction';
import AnalyticsDashboardDev from '../tensorAnalyticsDev/pages/analyticsDashboardPage/AnalyticsDashboardPage';
import DetectionResultsDev from '../tensorAnalyticsDev/pages/detectionResults/DetectionResults';
import DragDropDev from '../tensorAnalyticsDev/subComponents/dragDrop/DragDrop';


const Routes = withRouter(({
  history,
  reportData,
  sidebarVisible,
  session,
  mfaAuthCode,
  dispatch,
}) => {
  const isPremium = session && session.premium;

  history.listen(() => {
    dispatch(hideErrors());
  });
  return (
    <Switch>
      <Route path="/login"
        render={() => (! session && ! mfaAuthCode ? <LoginPage session={session} /> : <Redirect to="/" />)}
      />
      <Route path="/authentication"
        render={() => (mfaAuthCode ? <AuthenticationPage /> : <Redirect to="/" />)}
      />
      <Route path="/ping"
        render={() => 'Ok'}
      />
      { mfaAuthCode ? <Redirect to="/authentication" /> : null }
      {! session && ! mfaAuthCode ? <Redirect to="/login" /> : null}

      <Route path="/overview"
        render={() => (
          <MainLayout sidebarVisible={sidebarVisible}
            isPremium={isPremium}
          >
            <Overview data={reportData} />

          </MainLayout>
        )}
      />
      <Route path="/downloadDeviceReport"
        render={() => (
          <MainLayout sidebarVisible={sidebarVisible} isPremium={isPremium}>
            <DownloadDeviceReport data={reportData} />
          </MainLayout>
        )}
      />
      {isPremium && (
        <Route path="/meteredUsage"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <MeteredUsage data={reportData} />

            </MainLayout>
          )}
        />
      )}
      { isPremium && (
        <Route path="/devices"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <Devices data={reportData} />
            </MainLayout>
          )}
        />
      )}

      { isPremium && (
        <Route path="/transactions"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <Transactions data={reportData} />
            </MainLayout>
          )}
        />
      )}

      {isPremium && (
        <Route path="/onboardingAnalysis"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <OnboardingAnalysis data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/deviceTrends"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DeviceTrends data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/deviceSWAnalysis"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DeviceSWAnalysis data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/deviceUsageAnalysis"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DeviceUsageAnalysis data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/deviceDetails"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DeviceDetails data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/userAnalysis"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <UserAnalysis data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/notificationAnalysis"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <NotificationAnalysis data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/datapointTransmissionTrends"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DatapointTransmissionTrends data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && (
        <Route path="/datapointAnalysis"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DatapointAnalysis data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/analyticsDashboard"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <AnalyticsDashboard session={session} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/schedules"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <Schedules session={session} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/models"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <Models session={session} />
            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/detectionResults"
          render={props => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DetectionResults {...props} />
            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/deviceDetail/:deviceDSN"
          render={props => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <DeviceDetail data={reportData}
                {...props}
              />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/failurePrediction"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <FailurePrediction data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/subsystemBreakdown"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <DragDrop data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/analyticsDashboardDev"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <AnalyticsDashboardDev session={session} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/schedulesDev"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <SchedulesDev session={session} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/modelsDev"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <ModelsDev session={session} />
            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/detectionResultsDev"
          render={props => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >
              <DetectionResultsDev {...props} />
            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/deviceDetailDev/:deviceDSN"
          render={props => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <DeviceDetailDev data={reportData}
                {...props}
              />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/failurePredictionDev"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <FailurePredictionDev data={reportData} />

            </MainLayout>
          )}
        />
      )}
      {isPremium && process.env.REACT_APP_ANALYTIC_FEATURES_ENABLED === 'true' && (
        <Route path="/subsystemBreakdownDev"
          render={() => (
            <MainLayout sidebarVisible={sidebarVisible}
              isPremium={isPremium}
            >

              <DragDropDev data={reportData} />

            </MainLayout>
          )}
        />
      )}
      <Redirect to="/overview" />
    </Switch>
  );
});

const App = ({
  reportData,
  sidebarVisible,
  session,
  fetchData,
  dispatch,
  mfaAuthCode,
}) => (
  <div className="App">
    <Router>
      <Routes dispatch={dispatch}
        reportData={reportData}
        sidebarVisible={sidebarVisible}
        session={session}
        fetchData={fetchData}
        mfaAuthCode={mfaAuthCode}
      />
    </Router>
  </div>
);

export default connect(state => state)(App);
